import { render, staticRenderFns } from "./sidenav_menu.vue?vue&type=template&id=13a5f6e6&"
import script from "./sidenav_menu.vue?vue&type=script&lang=js&"
export * from "./sidenav_menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports